import { globals } from "../../globals";
import { logOut } from "./auth";
import { getBackGroundQueue, getLocalReviewRecord } from "./localReviewData";
import { hideModal } from "./modal";
// ------------------------------------
// Constants
// ------------------------------------
export const GET_COUNTRY_REGIONS_START = "GET_COUNTRY_REGIONS_START";
export const GET_COUNTRY_REGIONS_FETCHED = "GET_COUNTRY_REGIONS_FETCHED";
export const GET_COUNTRY_REGIONS_FAILURE = "GET_COUNTRY_REGIONS_FAILURE";
export const CREATE_NEW_LOCALITY_START = "CREATE_NEW_LOCALITY_START";
export const NEW_LOCALITY_CREATED = "NEW_LOCALITY_CREATED";
export const CREATE_NEW_LOCALITY_FAILURE = "CREATE_NEW_LOCALITY_FAILURE";
export const EDIT_LOCALITY_START = "EDIT_LOCALITY_START";
export const LOCALITY_EDITED = "LOCALITY_EDITED";
export const EDIT_LOCALITY_FAILURE = "EDIT_LOCALITY_FAILURE";
export const DELETE_LOCALITY_START = "DELETE_LOCALITY_START";
export const LOCALITY_DELETED = "LOCALITY_DELETED";
export const DELETE_LOCALITY_FAILURE = "DELETE_LOCALITY_FAILURE";
export const RESTORE_LOCALITY_START = "RESTORE_LOCALITY_START";
export const LOCALITY_RESTORED = "LOCALITY_RESTORED";
export const RESTORE_LOCALITY_FAILURE = "RESTORE_LOCALITY_FAILURE";
export const LOCALITY_DUPLICATE = "LOCALITY_DUPLICATE";
export const WAIT_FOR_QUEUE_START = "WAIT_FOR_QUEUE_START";
export const WAIT_FOR_QUEUE_SUCCESS = "WAIT_FOR_QUEUE_SUCCESS";
export const GET_COUNTRIES_START = "GET_COUNTRIES_START";
export const GET_COUNTRIES_FETCHED = "GET_COUNTRIES_FETCHED";
export const GET_COUNTRIES_FAILURE = "GET_COUNTRIES_FAILURE";
export const GET_ALL_REGIONS_START = "GET_ALL_REGIONS_START";
export const GET_ALL_REGIONS_FETCHED = "GET_ALL_REGIONS_FETCHED";
export const GET_ALL_REGIONS_FAILURE = "GET_ALL_REGIONS_FAILURE";
export const FILTER_REGIONS = "FILTER_REGIONS";
export const GET_POLITICAL_PARTIES_START = "GET_POLITICAL_PARTIES_START";
export const POLITICAL_PARTIES_FETCHED = "POLITICAL_PARTIES_FETCHED";
export const GET_POLITICAL_PARTIES_FAILURE = "GET_POLITICAL_PARTIES_FAILURE";
export const GET_SESSIONS_START = "GET_SESSIONS_START";
export const SESSIONS_FETCHED = "SESSIONS_FETCHED";
export const GET_SESSIONS_FAILURE = "GET_SESSIONS_FAILURE";
export const GET_LOCALITIES_BY_STATE_START = "GET_LOCALITIES_BY_STATE_START";
export const GET_LOCALITIES_BY_STATE_SUCCESS =
  "GET_LOCALITIES_BY_STATE_SUCCESS";
export const GET_LOCALITIES_BY_STATE_FAILURE =
  "GET_LOCALITIES_BY_STATE_FAILURE";
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getCountryCodeRegions,
  createNewLocality,
};

const headers = {
  "Content-Type": "application/json",
};

export function getCountryCodeRegions(countryCode) {
  return (dispatch) => {
    dispatch({ type: GET_COUNTRY_REGIONS_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/region/countrycode/${countryCode}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_COUNTRY_REGIONS_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_COUNTRY_REGIONS_FAILURE });
      });
  };
}

export function getCountries() {
  return (dispatch) => {
    dispatch({ type: GET_COUNTRIES_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/region/countries`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_COUNTRIES_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_COUNTRIES_FAILURE });
      });
  };
}

export function getAllRegions() {
  return (dispatch) => {
    dispatch({ type: GET_ALL_REGIONS_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/region/all`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_ALL_REGIONS_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_ALL_REGIONS_FAILURE });
      });
  };
}

// create new locality for local review
export function createNewLocality(rawData, actionType) {
  return (dispatch) => {
    dispatch({ type: CREATE_NEW_LOCALITY_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(rawData),
    };
    return fetch(`${globals.apiUrl}/locality`, options)
      .then((response) => {
        if (response.status === 409) {
          response.json().then((json) => {
            if (json) {
              dispatch({
                type: LOCALITY_DUPLICATE,
                payload: {
                  json,
                },
              });
            }
          });
          return null;
        } else if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: NEW_LOCALITY_CREATED,
            payload: {
              json,
            },
          });
          //FS: not sure if this line is needed after fixing STS-1135,
          //left it for any backwards compatibility
          dispatch(getLocalReviewRecord(json.LocalReviewId, actionType));
          ///////////////////////////////////////////////////////////////
          return json.LocalReviewId;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: CREATE_NEW_LOCALITY_FAILURE });
      });
  };
}

// update local review locality
export function updateLocality(rawData, trackData) {
  return (dispatch) => {
    dispatch({ type: EDIT_LOCALITY_START });
    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(rawData),
    };
    fetch(`${globals.apiUrl}/locality`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: LOCALITY_EDITED,
            payload: {
              json,
            },
          });
          const actionType = trackData.queryLine.radio.query;
          dispatch({ type: WAIT_FOR_QUEUE_START });
          dispatch(getBackGroundQueue(actionType));
          dispatch(hideModal("Edit-item-localities"));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: EDIT_LOCALITY_FAILURE });
      });
  };
}

// delete locality for local review
export function deleteLocality(localityId, trackData) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCALITY_START });
    const options = {
      method: "DELETE",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/locality/${localityId}`, options)
      .then((response) => {
        if (response.status === 200) {
          const actionType = trackData.queryLine.radio.query;
          dispatch({
            type: LOCALITY_DELETED,
            payload: { json: localityId },
          });
          dispatch({ type: WAIT_FOR_QUEUE_START });
          dispatch(getBackGroundQueue(actionType));
          dispatch(hideModal("Delete-localities"));
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LOCALITY_FAILURE });
      });
  };
}

export function restoreLocality(rawData) {
  return (dispatch) => {
    dispatch({ type: RESTORE_LOCALITY_START });
    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(rawData),
    };
    return fetch(`${globals.apiUrl}/locality`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: LOCALITY_RESTORED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: RESTORE_LOCALITY_FAILURE });
      });
  };
}

function returnCountries(countries) {
  return countries.map((item) => {
    return {
      value: item,
      label: item,
    };
  });
}

export function returnRegions(regions) {
  return [
    { value: "all", label: "All" },
    ...regions
      .map((item) => {
        return {
          value: item.ShortName,
          label: item.Name,
        };
      })
      .filter((elem) => {
        return elem.label !== "All States"
          // && elem.label !== "Canada" - 
          && elem.label !== "Spain"
      }),
  ];
}

export function filterRegions(regions, country, page) {
  const newRegions = regions.filter((item) => {
    if (country !== "all") {
      return item.CountryCode === country;
    } else return item;
  });
  return {
    type: FILTER_REGIONS,
    payload: {
      json: newRegions,
      country,
      page,
    },
  };
}

export function getPoliticalParties(countryCode) {
  return (dispatch) => {
    dispatch({ type: GET_POLITICAL_PARTIES_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(
      `${globals.apiUrl}/region/countrycoderegionextended/${countryCode}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POLITICAL_PARTIES_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_POLITICAL_PARTIES_FAILURE });
      });
  };
}

export function getCountryCodeSessions(countryCode) {
  return (dispatch) => {
    dispatch({ type: GET_SESSIONS_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(
      `${globals.apiUrl}/region/countrycodesessions/${countryCode}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SESSIONS_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_SESSIONS_FAILURE });
      });
  };
}

export function getAllActiveSessions() {
  return (dispatch) => {
    dispatch({ type: GET_SESSIONS_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(
      `${globals.apiUrl}/region/allactivesessions/`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SESSIONS_FETCHED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_SESSIONS_FAILURE });
      });
  };
}

export function getLocalitiesByState(state) {
  return (dispatch) => {
    dispatch({ type: GET_LOCALITIES_BY_STATE_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/locality/${state}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCALITIES_BY_STATE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCALITIES_BY_STATE_SUCCESS,
            payload: {
              json,
              stateId: state,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCALITIES_BY_STATE_FAILURE });
      });
  };
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_COUNTRY_REGIONS_START]: (state) => {
    return {
      ...state,
      isLocalityFetching: true,
    };
  },
  [GET_COUNTRY_REGIONS_FETCHED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        countryRegions: json,
      },
    };
  },
  [CREATE_NEW_LOCALITY_START]: (state) => {
    return {
      ...state,
      isLocalityFetching: true,
    };
  },
  [NEW_LOCALITY_CREATED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        newLocality: json,
        duplicatedName: null,
      },
    };
  },
  [CREATE_NEW_LOCALITY_FAILURE]: (state) => {
    return {
      ...state,
      isLocalityFetching: false,
    };
  },
  [LOCALITY_DUPLICATE]: (state, action) => {
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        duplicatedName: action.payload.json,
      },
    };
  },
  [LOCALITY_DELETED]: (state) => {
    return {
      ...state,
    };
  },
  GET_LOCAL_RECORD_FETCHED: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        newLocality: json,
        duplicatedName: null,
      },
    };
  },
  [WAIT_FOR_QUEUE_START]: (state) => {
    return {
      ...state,
      isLocalityFetching: true,
    };
  },
  [WAIT_FOR_QUEUE_SUCCESS]: (state) => {
    return {
      ...state,
      isLocalityFetching: false,
    };
  },
  [GET_COUNTRIES_FETCHED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        countriesList: json,
        countries: returnCountries(json),
      },
    };
  },
  [GET_ALL_REGIONS_FETCHED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isLocalityFetching: false,
      renderData: {
        ...state.renderData,
        allRegions: returnRegions(json),
        regions: json,
      },
    };
  },
  [FILTER_REGIONS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRegions: returnRegions(json),
      },
    };
  },
  [GET_POLITICAL_PARTIES_START]: (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        isFetchingPatries: true,
      },
    };
  },
  [POLITICAL_PARTIES_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        isFetchingPatries: false,
        politParties: action.payload.json,
      },
    };
  },
  [SESSIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        rawSessions: action.payload.json,
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isLocalityFetching: true,
  renderData: {
    countryRegions: [],
    allRegions: [],
  },
};
export default function regionsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/regions.js